import { render } from "./Inventory.vue?vue&type=template&id=6fc7ec92"
import script from "./Inventory.vue?vue&type=script&lang=js"
export * from "./Inventory.vue?vue&type=script&lang=js"

import "./Inventory.vue?vue&type=style&index=0&id=6fc7ec92&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/smartsim-ui-new/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__